<template lang="html">

  <section class="casos-de-exito" v-if="typeof data == 'object'">

    <div class="container">

      <h3 class="title -intro">{{$t('clientes.caso_exito.titleMain')}}</h3>

      <h2 class="title">{{data.titulo}}</h2>

      <p>{{data.intro}}</p>

    </div>

    <div class="seccion-imagen">

      <div class="contenedor-imagen animate row-end">

        <img :src="data.imagen" :alt="data.titulo">

      </div>

      <div class="texto container" v-html="data.texto"></div>

    </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'casos-exito',
    props: ['data'],
  }
</script>

<style scoped >
.casos-de-exito{
  background: rgba(51, 116, 176, 0.1);
  padding: 50px 0 0 0;
}

.casos-de-exito .title.-intro{
  text-align: left;
  font-size: 24px;
  margin-bottom: 10px;
}

.casos-de-exito .title.-intro::before{
  bottom: 0px;
  height: 15px;
  width: 100px;
}

.casos-de-exito .title:not(.-exito){
  text-align: left;
  max-width: 768px;
  color: #3374b0;
  margin-bottom: 20px;
}

.casos-de-exito p{
  text-align: left;
  width: 100%;
  max-width: 400px;
  color: #41566d;
  margin-bottom: 0px;
}

.seccion-imagen{
  position: relative;
}

.seccion-imagen .texto{
  text-align: right;
  min-height: 406px;
  padding-left: 40%;
}

@media screen and (max-width: 1550px){
  .seccion-imagen .texto{
    padding-left: 45%;
  }
}

@media screen and (max-width: 1350px){
  .seccion-imagen .texto{
    padding-left: 50%;
  }
}

@media screen and (max-width: 1250px){
  .seccion-imagen .texto{
    padding-left: 55%;
  }
}


.contenedor-imagen{
  position: absolute;
  left: 0;
  width: 47%;
  bottom: -50px;
  background: #41566d;
  transform: translateX(-110%);
  overflow: hidden;
  transform: translateX(-110%);
  transition: .7s;
  transition-timing-function: ease-in-out;
  will-change:transform;
  transition-delay: .5s;
}


@media screen and (max-width: 769px){
  .contenedor-imagen{
    display: none;
  }
  
  .seccion-imagen .texto{
    padding-left: 20px;
    padding-bottom: 40px;
    min-height: 0;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/parts/casos-exito.vue